import React, { useContext, useRef, useEffect } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { strToDate, DATE_FORMAT, todayLastYearDate } from '../../utils/DateUtils';
import useExcludedSupplierPresenter from './ExcludedSupplierQualityCertificatePresenter';
import ExcludedSuppliersGrid from './ExcludedSupplierQualityCertificateGrid';
import SupplierFilter from '../../components/SupplierFilter/SupplierFilter';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const {

    selectedSupplier,
    setSelectedSupplier,

    validateAndSearch,
    cleanFilters,
    
  } = filtersProps;


  return (
    <div className={classes.filters}>
      
      <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />
      
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const ExcludedSuppliers = () => {
  const tableRef = useRef();
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useExcludedSupplierPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <ExcludedSuppliersGrid data={rows} loading={loading} tableRef={tableRef} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default ExcludedSuppliers;